import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  getActiveWageredAmountCounter,
  getFutureWageredAmountCounter,
  getIsMyBetsPastPerformanceOpen,
  getMyBetsCounterToggle,
  getSelectedTab,
  getSettledWageredAmountCounter,
  getTodayActiveCounter,
  getTodayFutureCounter,
  getTodaySettledCounter
} from "@tvg/sh-lib-my-bets/redux/selectors";
import { formatCurrency } from "@tvg/formatter";
import pluralize from "@tvg/utils/generalUtils";

export const useCounters = () => {
  const selectedTab = useSelector(getSelectedTab);
  const activeBetsCounter = useSelector(getTodayActiveCounter);
  const settledBetsCounter = useSelector(getTodaySettledCounter);
  const futureBetsCounter = useSelector(getTodayFutureCounter);
  const activeWageredAmount = useSelector(getActiveWageredAmountCounter);
  const settledWageredAmount = useSelector(getSettledWageredAmountCounter);
  const futureWageredAmount = useSelector(getFutureWageredAmountCounter);
  const [counters, setCounters] = useState({
    counter: activeBetsCounter,
    amount: activeWageredAmount
  });

  useEffect(() => {
    switch (selectedTab) {
      case "SETTLED":
        setCounters({
          counter: settledBetsCounter,
          amount: settledWageredAmount
        });
        break;
      case "FUTURES":
        setCounters({
          counter: futureBetsCounter,
          amount: futureWageredAmount
        });
        break;
      case "ACTIVE":
      default:
        setCounters({
          counter: activeBetsCounter,
          amount: activeWageredAmount
        });
        break;
    }
  }, [
    selectedTab,
    settledBetsCounter,
    settledWageredAmount,
    futureBetsCounter,
    futureWageredAmount,
    activeBetsCounter,
    activeWageredAmount
  ]);

  return counters;
};

export const useBetsInfo = () => {
  const myBetsCounterToggle = useSelector(getMyBetsCounterToggle);
  const isPastPerformanceOpen = useSelector(getIsMyBetsPastPerformanceOpen);
  const counters = useCounters();

  return useMemo(() => {
    if (!myBetsCounterToggle || isPastPerformanceOpen) {
      return [];
    }

    return [
      {
        label: counters.counter,
        description: pluralize(counters.counter, "Bet", false),
        qaLabel: "bet-counter"
      },
      {
        label: formatCurrency(counters.amount),
        description: "Wagered",
        qaLabel: "amount-wagered"
      }
    ];
  }, [myBetsCounterToggle, isPastPerformanceOpen, counters]);
};
